import apiCall from '../../apiCall/apiCall';
import buildUrlSearchParams from '../../apiCall/buildUrlSearchParams/buildUrlSearchParams';
// This class handles any API calls related to goods-in-type vehicles.
class GoodsIn {
  static all(params) {
    const data = buildUrlSearchParams(params);
    return apiCall('GET', 'api/warehouses/goods_in', data);
  }

  static show(category, id) {
    const data = buildUrlSearchParams({ category: category });
    return apiCall('GET', `api/warehouses/goods_in/${id}`, data);
  }

  static start(category, id) {
    const data = { category: category };
    return apiCall('POST', `api/warehouses/goods_in/${id}/start`, data);
  }

  static cancel(category, id) {
    const data = { category: category };
    return apiCall('POST', `api/warehouses/goods_in/${id}/cancel`, data);
  }

  static confirm(category, id, reasons) {
    const data = { category: category, reasons: reasons };
    return apiCall('POST', `api/warehouses/goods_in/${id}/confirm`, data);
  }

  static unconfirm(category, id) {
    const data = { category: category };
    return apiCall('POST', `api/warehouses/goods_in/${id}/unconfirm`, data);
  }

  static updateExpectedArrivalTime(category, id, expectedDate, expectedHour) {
    const data = {
      category: category,
      expectedDate: expectedDate,
      expectedHour: expectedHour,
    };

    return apiCall('POST', `api/warehouses/goods_in/${id}/update_arrival_time`, data);
  }
  static updateArrivalTime(category, actual, id) {
    const data = { category: category, actual: actual };
    return apiCall('POST', `api/warehouses/goods_in/${id}/update_arrival_time`, data);
  }

  static updateDefaultBay(category, bay, id) {
    const data = { category: category, bayId: bay };
    return apiCall('POST', `api/warehouses/goods_in/${id}/update_default_bay`, data);
  }

  static updatePackageCount(category, id, jobId, quantity) {
    const params = { category: category, jobId: jobId, quantity: quantity };
    return apiCall('POST', `api/warehouses/goods_in/${id}/update_package_count`, params);
  }
}

export default GoodsIn;
